export const getDesignToChooseData = () => {

    const intro = {
        title: '',
        intro: 'With a team of certified and experienced game developers, we have created mobile games for almost all sectors. Each and every project is important for us. This is what helps us become a reliable partner of our clients when it comes to game development. Here’s what made us a perfect choice as a mobile game development company'
    };

    const data = [
        {
            title: 'Customer Satisfaction',
            description: 'We work on the latest frameworks and technologies to deliver you user-friendly, scalable, secure, and new business solutions as per your need.'
        },
        {
            title: 'Agile Procedure',
            description: 'We work on the Agile methodology and conduct frequent scrum events for optimizing the practices and methods and delivering the finest results.'
        },
        {
            title: 'Dedicated Teams',
            description: 'We have a dedicated team of UI/UX designers who are well versed in delivering high-end business solutions on several tools and technologies.'
        },
        {
            title: 'Integrity & Transparency',
            description: 'We respect your ideas and vision, provide you every small project detail regularly, and consider your worthy advice when and as needed.'
        },
        {
            title: 'Flexible Engagement Models',
            description: 'Instead of working on unwanted rigid and strict parameters, we offer flexibility to our clients to select from different engagement and hiring models.'
        },
        {
            title: 'Competitive Pricing',
            description: 'We offer an ideal combination of cost-effective rates with amazing quality to make sure the lowest pricing in our segment.'
        },
    ]
    return { intro, data };
}